// Converts an ISO string to a time string in HH:MM format
export const convertToTime = isoString => {
    if (!isoString) return null;

    const [datePart, timePart] = isoString.split("T");
    if (!timePart) return null;

    const [hour, minute] = timePart.split(":");
    return `${hour}:${minute}`;
};

// Converts milliseconds to a formatted string of hours and minutes (HH:MM)
export function millisecondsToHoursAndMinutes(durationInMs) {
    const MILLISECONDS_PER_MINUTE = 60000;
    const MINUTES_PER_HOUR = 60;
    const HOURS_PER_DAY = 24;

    const totalMinutes = Math.floor(durationInMs / MILLISECONDS_PER_MINUTE);
    const hours = Math.floor(totalMinutes / MINUTES_PER_HOUR) % HOURS_PER_DAY;
    const minutes = totalMinutes % MINUTES_PER_HOUR;

    const padToTwoDigits = num => num.toString().padStart(2, "0");
    return `${padToTwoDigits(hours)}:${padToTwoDigits(minutes)}`;
}

export function addTimes(timeMap) {
    let totalH = 0;
    let totalM = 0;

    for (let x in timeMap) {
        totalH += parseInt(timeMap[x]?.split(":")[0]);
        totalM += parseInt(timeMap[x]?.split(":")[1]);
    }

    if (totalM >= 60) {
        totalH += Math.floor(totalM / 60);
        totalM = totalM % 60;
    }
    return totalH + ":" + totalM;
}

// Sums an array of time strings in the format "HH:MM" and returns the total time
export function sumTimes(times) {
    let totalHours = 0;
    let totalMinutes = 0;

    times.forEach(time => {
        if (time) {
            const [hours, minutes] = time.split(':').map(Number);
            totalHours += hours;
            totalMinutes += minutes;
        }
    });

    totalHours += Math.floor(totalMinutes / 60);
    totalMinutes %= 60;

    return `${totalHours.toString().padStart(2, '0')}:${totalMinutes.toString().padStart(2, '0')}`;
}
